import { gql, useQuery } from '@apollo/client';
import { DateTime } from 'luxon';

const GET_NUMBER_OF_DUE_SERVICE_CONTRACTS = gql`
  query GetNumberOfDueServiceContracts($dueDate: Date!) {
    getNumberOfDueServiceContracts(dueDate: $dueDate)
  }
`;

export const useNumberOfDueServiceContracts = ({
  dueDate: date,
}: {
  dueDate: string;
}): [number, boolean] => {
  const dueDate =
    date && DateTime.fromISO(date).isValid
      ? DateTime.fromISO(date).toISODate()
      : null;
  const response = useQuery(GET_NUMBER_OF_DUE_SERVICE_CONTRACTS, {
    variables: { dueDate },
    skip: !dueDate,
  });
  const data = response?.data?.getNumberOfDueServiceContracts;
  const loading = response.loading;
  return [data, loading];
};
